import { useCore } from '@/composables/core'

type RelativeDeltaObject = Record<string, number>

type FormatRelativeDeltaOptions = {
  withSpace?: boolean
}

export const formatRelativeDelta = (obj: RelativeDeltaObject, { withSpace = true }: FormatRelativeDeltaOptions = {}): string => {
  const { t } = useCore()
  const UNITS_LABELS: [string, string][] = [
    ['years', t('years-genitive-case')],
    ['year', t('year')],
    ['months_accusative', t('months-accusative-case')],
    ['months', t('months-genitive-case')],
    ['month', t('month')],
    ['weeks', t('weeks-genitive-case')],
    ['week', t('week')],
    ['days', t('days-genitive-case')],
    ['day', t('day')],
    ['hours_accusative', t('hours-accusative-case')],
    ['hours', t('hours-genitive-case')],
    ['hour', t('hour')],
    ['minutes', t('minutes-genitive-case')],
    ['minute', t('minute')],
    ['seconds', t('seconds-genitive-case')],
    ['second', t('second')],
    ['microseconds', t('microseconds-genitive-case')],
    ['microsecond', t('microsecond')],
  ]

  const ret: string[] = []
  for (const [unit, label] of UNITS_LABELS) {
    if (obj[unit] !== undefined) {
      const count = obj[unit]
      if (withSpace) ret.push(`${count} ${label}`)
      else ret.push(`${count}${label}`)
    }
  }
  return ret.join(', ')
}
